import { api } from './api';

export type AnleitungArt = 'text' | 'video' | 'beides';

export interface Anleitung {
  id: string;
  titel: string;
  kurz: string;
  art: AnleitungArt;
  dauer: number;
  text?: string;
  videoUrl?: string;
  bilder?: string[];
  /** Vorschaubild der Kachel; fehlt es, zeichnet die Oberfläche eine Ersatzfläche. */
  vorschau?: string;
  seit: string;
  /** Statischer Rücksprung-CTA im Lesefenster, falls ein konkreter Software-Sprung Sinn
   *  ergibt (z.B. "Neuen Kunden anlegen"). Nur Fallback — ein dynamischer Rücksprung zur
   *  zuvor geöffneten Seite (siehe HilfeLink/?zurueck=) hat immer Vorrang. */
  ziel?: { pfad: string; label: string };
}

export interface AnleitungsKategorie {
  id: string;
  titel: string;
  beschreibung: string;
  symbol: string;
  anleitungen: Anleitung[];
}

export interface AnleitungenAntwort {
  kategorien: AnleitungsKategorie[];
  /** Angesehen ODER abgeschlossen — jede Anleitung mit mindestens einer Zeile in der DB. */
  gelesen: string[];
  /** Nur die aktiv über „Als erledigt markieren" bestätigten. */
  erledigt: string[];
  ungelesen: number;
}

export const ladeAnleitungen = () => api.get<AnleitungenAntwort>('/api/anleitungen');
export const ladeUngelesen = () => api.get<{ ungelesen: number; gesamt: number }>('/api/anleitungen/ungelesen');
export const merkeGelesen = (id: string) => api.post<{ ok: true }>(`/api/anleitungen/${id}/gelesen`, {});
export const merkeUngelesen = (id: string) => api.delete<{ ok: true }>(`/api/anleitungen/${id}/gelesen`);
export const alleGelesen = () => api.post<{ ok: true }>('/api/anleitungen/alle-gelesen', {});
export const markiereErledigt = (id: string) => api.post<{ ok: true }>(`/api/anleitungen/${id}/erledigt`, {});

/** Wie viele Anleitungen einer Kategorie sind schon abgeschlossen? */
export function fortschritt(kategorie: AnleitungsKategorie, erledigt: Set<string>): { gelesen: number; gesamt: number } {
  return {
    gelesen: kategorie.anleitungen.filter((a) => erledigt.has(a.id)).length,
    gesamt: kategorie.anleitungen.length,
  };
}

/** „Neu" heißt: in den letzten 30 Tagen dazugekommen UND noch nicht gesehen. */
export function istNeu(a: Anleitung, gelesen: Set<string>, jetzt = Date.now()): boolean {
  if (gelesen.has(a.id)) return false;
  const seit = new Date(a.seit).getTime();
  return !isNaN(seit) && jetzt - seit < 30 * 86400000;
}

export const ART_LABEL: Record<AnleitungArt, string> = {
  text: 'Text',
  video: 'Video',
  beides: 'Text + Video',
};
